import { render, staticRenderFns } from "./PassesPosession.vue?vue&type=template&id=4e883fa7&scoped=true&"
import script from "./PassesPosession.vue?vue&type=script&lang=js&"
export * from "./PassesPosession.vue?vue&type=script&lang=js&"
import style0 from "./PassesPosession.vue?vue&type=style&index=0&id=4e883fa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e883fa7",
  null
  
)

export default component.exports